import { TOTAL_QURAN_VERSES } from '@components/shared/consts'

interface ReadingProgressBarProps {
  versesReadToday: number
  dailyGoal: number
  currentVerse: number
}

const ReadingProgressBar = ({
  versesReadToday,
  dailyGoal,
  currentVerse,
}: ReadingProgressBarProps) => {
  const goalProgress = Math.min((versesReadToday / dailyGoal) * 100, 100)
  const quranProgress = ((currentVerse / TOTAL_QURAN_VERSES) * 100).toFixed(1)

  // Calculate approximate juz (each juz ≈ 20 pages ≈ ~specific verse ranges)
  const juz = Math.ceil(currentVerse / (TOTAL_QURAN_VERSES / 30))

  return (
    <div className="px-4 py-3 relative z-10">
      {/* Progress bar */}
      <div className="w-full h-2 bg-surface-subtle border border-main rounded-full overflow-hidden">
        <div
          className="h-full bg-brand-secondary rounded-full transition-all duration-700 ease-out"
          style={{ width: `${goalProgress}%` }}
        />
      </div>

      {/* Labels */}
      <div className="flex items-center justify-between mt-2 text-[10px] font-bold uppercase tracking-wider text-main/60">
        <span>
          {versesReadToday} / {dailyGoal} Ayet
        </span>
        <span className="text-brand-secondary font-black">{quranProgress}% Tamam</span>
        <span>Cüz {juz}</span>
      </div>
    </div>
  )
}

export default ReadingProgressBar
